import { Navbar, NavbarInset } from '@/shared/components/ui/nav-bar/nav-bar';

export const NavbarLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Navbar>
      <NavbarInset>{children}</NavbarInset>
    </Navbar>
  );
};
